export enum FilterState {
    All,
    Standard,
    Enhanced
}
